import React, { useState } from "react";
import { motion } from "framer-motion";
import { SERVICES } from "../data/content";

function ServiceCard({ s, i }) {
  const [flipped, setFlipped] = useState(false);
  return (
    <motion.div
      data-testid={`service-card-${i}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: i * 0.08, ease: [0.7, 0, 0.2, 1] }}
      className="relative h-[320px] md:h-[360px] cursor-pointer"
      style={{ perspective: 1200 }}
      onClick={() => setFlipped((v) => !v)}
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
    >
      <motion.div
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ duration: 0.8, ease: [0.7, 0, 0.2, 1] }}
        className="relative w-full h-full"
        style={{ transformStyle: "preserve-3d" }}
      >
        {/* Front */}
        <div
          className="absolute inset-0 rounded-sm bg-[#12141D] border border-white/5 p-8 md:p-10 flex flex-col justify-between"
          style={{ backfaceVisibility: "hidden" }}
        >
          <div className="font-display text-7xl text-[#D18A58]/30 leading-none">{s.n}</div>
          <div>
            <div className="text-[10px] uppercase tracking-overline text-[#D18A58] mb-3">Service</div>
            <h3 className="font-display text-3xl md:text-4xl text-[#F2EBE5] leading-tight">
              {s.title}
            </h3>
            <div className="mt-6 text-xs uppercase tracking-overline text-[#8A8D98]">
              Hover to expand →
            </div>
          </div>
        </div>
        {/* Back */}
        <div
          className="absolute inset-0 rounded-sm overflow-hidden text-[#F2EBE5] p-8 md:p-10 flex flex-col justify-between"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
        >
          <img src={s.image} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#D18A58]/85 via-[#8A5A53]/85 to-[#0B0E14]/90" />
          <div className="relative font-display text-7xl text-[#F2EBE5]/30 leading-none">{s.n}</div>
          <div className="relative">
            <h3 className="font-display text-2xl md:text-3xl leading-tight mb-4">{s.title}</h3>
            <p className="text-sm md:text-base text-[#F2EBE5]/90 leading-relaxed">{s.desc}</p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#0B0E14] text-[#F2EBE5] py-24 md:py-36"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div>
            <div className="flex items-center gap-3 text-[10px] tracking-overline uppercase text-[#D18A58] mb-5">
              <span className="h-px w-10 bg-[#D18A58]" />
              Practice · 03
            </div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight">
              What I <span className="italic text-[#D18A58]">offer</span>.
            </h2>
          </div>
          <p className="max-w-md text-sm md:text-base text-[#C5A29B] leading-relaxed">
            Six core services — woven across editorial, brand and experience. Hover or tap a card to read more.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {SERVICES.map((s, i) => <ServiceCard key={s.n} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
}
